<template>
    <v-dialog
            v-model="dialog"
            max-width="1000"
            :fullscreen="$vuetify.breakpoint.xsOnly"
    >
        <v-card>
            <v-card-text
                    :class="{
                        'pa-5': !$vuetify.breakpoint.xsOnly,
                        'c-pa-10': $vuetify.breakpoint.xsOnly
                    }"
            >
                <popup-header
                        :title="model.id === null ? $t('msg.addingTaskForWeek') : $t('msg.editingTaskForWeek')"
                        class="mb-4"
                        @click-close="dialog = false"
                ></popup-header>
                <card-cols>
                    <template v-slot:left>
                        <v-textarea
                                v-model="model.name"
                                :label="$t('msg.name')"
                                data-vv-name="name"
                                :error-messages="errors.collect('name')"
                                hide-details="auto"
                                outlined
                                :dense="!isMobile"
                                ref="inputName"
                        ></v-textarea>
                        <v-combobox
                          v-model="model.tag"
                          :label="$t('msg.markers')"
                          :error-messages="errors.collect('tags')"
                          data-vv-name="tags"
                          multiple
                          small-chips
                          hide-selected
                          clearable
                          deletable-chips
                          :dense="!isMobile"
                          outlined
                          hide-details="auto"
                          class="mt-3"
                        ></v-combobox>
                        <duration
                          v-model="model.duration"
                          :label="$t('msg.approximateDuration')"
                          style="margin-top: 11px"
                        ></duration>
                    </template>
                    <template v-slot:right>
                        <v-autocomplete
                                v-model="model.project_id"
                                :label="$t('msg.project')"
                                :error-messages="errors.collect('project_id')"
                                data-vv-name="project"
                                :items="getProjects"
                                item-text="name"
                                item-value="id"
                                hide-selected
                                clearable
                                deletable-chips
                                outlined
                                dense
                                hide-details="auto"
                                :dense="!isMobile"
                        >
                            <template
                                    v-if="!!model.project_id"
                                    v-slot:append-outer
                            >
                                <link-entity
                                        :to="{name: 'tasks', params: {id: model.project_id}}"
                                ></link-entity>
                            </template>
                        </v-autocomplete>
                        <v-autocomplete
                                v-if="!!model.project_id"
                                v-model="model.task_id"
                                :label="$t('msg.task')"
                                :error-messages="errors.collect('task_id')"
                                data-vv-name="task_id"
                                :items="getTasks"
                                item-text="name"
                                item-value="id"
                                hide-selected
                                clearable
                                deletable-chips
                                outlined
                                :dense="!isMobile"
                                hide-details="auto"
                                class="mt-3"
                        >
                            <template
                                    v-if="!!model.task_id"
                                    v-slot:append-outer
                            >
                                <link-entity
                                        :to="{name: 'tasks', params: {id: model.project_id}, query: {task_id: model.task_id}}"
                                ></link-entity>
                            </template>
                        </v-autocomplete>
                        <!--<v-autocomplete
                                v-model="model.note_id"
                                :label="$t('msg.note')"
                                :error-messages="errors.collect('note_id')"
                                data-vv-name="tags"
                                :items="notes"
                                item-text="name"
                                item-value="id"
                                hide-selected
                                clearable
                                deletable-chips
                                outlined
                                dense
                                hide-details="auto"
                                class="mt-3"
                        >
                            <template
                                    v-if="!!model.note_id"
                                    v-slot:append-outer
                            >
                                <link-entity
                                        :to="{name: 'note', params: {id: model.note_id}}"
                                ></link-entity>
                            </template>
                        </v-autocomplete>-->
                        <c-switch
                                v-if="!!model.id"
                                v-model="model.is_done"
                                :label="$t('msg.isDone')"
                                class="mt-3"
                        ></c-switch>
                        <c-switch
                                v-if="!!model.id"
                                v-model="model.is_archive"
                                :label="$t('msg.isArchive')"
                                class="mt-3"
                        ></c-switch>
                    </template>
                </card-cols>
                <btns-wrap class="mt-2">
                    <c-btn
                            color="primary"
                            @click="dialog = false"
                    >{{ $t('msg.cancel') }}</c-btn>
                    <c-btn
                            color="primary"
                            class="ml-3"
                            :loading="loading"
                            @click="save()"
                    >{{ $t('msg.save') }}</c-btn>
                </btns-wrap>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import CardCols from "../../ui/CardCols";
    import DateTime from "../../ui/DateTime";
    import LinkEntity from "../../ui/LinkEntity";
    import PopupHeader from "../../ui/PopupHeader";
    import CSwitch from "../../ui/CSwitch";
    import CBtn from "../../ui/CBtn";
    import BtnsWrap from "../../ui/BtnsWrap";
    import Duration from "@/components/ui/DurationInput";

    export default {
        components: {CardCols, DateTime, LinkEntity, PopupHeader, CSwitch, CBtn, BtnsWrap, Duration},
        props: {
            projects: Array,
            notes: Array
        },
        data() {
            return {
                model: {
                    id: null,
                    week: null,
                    project_id: null,
                    task_id: null,
                    note_id: null,
                    name: null,
                    is_done: null,
                    is_archive: null,
                    duration: null,
                    tag: null,
                },
                dialog: false,
                loading: false,
                tasks: []
            };
        },
        watch: {
            'model.project_id': {
                handler() {
                    this.loadTasks();
                }
            }
        },
        computed: {
          getTasks() {
            let ret = [];

            this.tasks.forEach(task => {

              if ((!task.is_archive && !task.is_done) || task.id === this.model.task_id) {
                ret.push({
                  id: task.id,
                  name: task.name
                });
              }

              task.sub_tasks.forEach(subTask => {

                if ((!subTask.is_archive && !subTask.is_done) || subTask.id === this.model.task_id) {
                  ret.push({
                    id: subTask.id,
                    name: task.name + ' > ' + subTask.name
                  });
                }

              });
            });

            return ret;
          },
            getProjects() {
                return this.model.id ? this.projects : this.projects.filter(v => v.is_archive == false);
            }
        },
        methods: {
            createModel(week) {
                this.clearModel();
                this.dialog = true;
                this.errors.clear();
                this.model.week = week;
                setTimeout(() => {
                    if (this.$vuetify.breakpoint.lgAndUp) {
                        this.$refs.inputName.focus();
                    }
                }, 500);
            },
            openModel(model) {
                this.model.id = model.id;
                this.model.week = model.week;
                this.model.project_id = model.project_id;
                this.model.task_id = model.task_id;
                this.model.note_id = model.note_id;
                this.model.month_plan_id = model.month_plan_id;
                this.model.name = model.name;
                this.model.is_done = model.is_done;
                this.model.is_archive = model.is_archive;
                this.model.duration = model.duration;
                this.model.tag = model.tag;
                this.errors.clear();
                this.dialog = true;
            },
            clearModel() {
                this.model.id = null;
                this.model.project_id = null;
                this.model.task_id = null;
                this.model.note_id = null;
                this.model.month_plan_id = null;
                this.model.name = null;
                this.model.is_done = null;
                this.model.is_archive = null;
                this.model.duration = null;
                this.model.tag = null;
            },
            save() {
                let customValid = this.customValid();
                this.$validator.validateAll()
                    .then(valid => {
                        if (valid && customValid) {
                            let action = !!this.model.id ? 'updateWeekPlan' : 'createWeekPlan';
                            this.loading = true;
                            this.$store.dispatch(action, {
                                data: this.model,
                                id: this.model.id
                            })
                                .then(() => {
                                    this.$emit('saved');
                                    this.dialog = false
                                })
                                .finally(() => this.loading = false);
                        }
                    });
            },
            customValid() {

                this.errors.clear();

                if (!this.model.name && !this.model.task_id && !this.model.note_id) {

                    this.errors.add({
                        field: 'name',
                        msg: this.$t('msg.oneOfFieldsMustBeFilled')+': '+this.$t('msg.name')+', '+this.$t('msg.task')+' '+this.$t('msg.or')+' '+this.$t('msg.note'),
                    });

                    return false;
                }

                return true;
            },
            loadTasks() {
                if (!this.model.project_id) return;
                this.$store.dispatch('loadTasks', {id: this.model.project_id})
                    .then(res => this.tasks = res);
            }
        }
    }
</script>